import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IdleTimer from 'react-idle-timer';
import { Modal, Button, ModalBody, ModalFooter, Row, Col } from 'react-bootstrap';
import { loginActions } from '../../../store/user-login.reducer';
import { areObjectsEqual } from '../../../utils/helpers.utils'

class SessionExpModal extends Component {
    constructor(props) {
        super(props)
        this.idleTimer = null;
        this.state = {
            showModal: false,
            idleWarnings: 0,
            uiTimeOutDetails: this.props.uiTimeOutDetails,
            isLoggedIn: sessionStorage.getItem('access_token') !== null
        }

        this.onAction = this.onAction.bind(this);
        this.onActive = this.onActive.bind(this);
        this.onIdle = this.onIdle.bind(this);
    }

    async componentDidMount() {
        await this.props.setUIIdleTime();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isSilentRenewError !== prevProps.isSilentRenewError && this.props.isSilentRenewError) {
            this.props.silentRenewErrorAct();
        }
        if (!areObjectsEqual(this.props.uiTimeOutDetails, prevProps.uiTimeOutDetails)) {
            this.resetTimer()
        }
    }

    logout = async (event) => {
        event.preventDefault();
        this.props.logout();
    };

    continueSession = async (event) => {
        event.preventDefault();
        this.setState({
            idleWarnings: 0,
            showModal: false
        })
    };

    getTimeLeft = () => {
        const { idleWarningNotif, idleDuration } = this.state.uiTimeOutDetails
        var timeLeft = 0;

        idleWarningNotif.forEach((element, index) => {
            if ((this.state.idleWarnings - 1) >= index) {
                timeLeft = timeLeft + element;
            }
        });
        return (idleDuration - timeLeft);
    }
    resetTimer = () => {
        this.setState({ 
            uiTimeOutDetails: this.props.uiTimeOutDetails,
            showModal: false
         });
        this.idleTimer.reset()
        this.forceUpdate();
    }

    onAction = (e) => {
        this.idleTimer.reset()
        this.forceUpdate();
    }

    onActive = (e) => {
        this.forceUpdate();
    }

    onIdle = (e) => {
        const { idleWarningNotif } = this.state.uiTimeOutDetails;
        if (!this.state.isLoggedIn)
            return;
        if ((idleWarningNotif.length - 1) == this.state.idleWarnings) {
            this.props.logout();
            return;
        }
        console.log(this.idleTimer);
        this.setState({
            idleWarnings: this.state.idleWarnings + 1,
            showModal: true,
        }, () => {
            idleWarningNotif.forEach((element, index) => {
                if (this.state.idleWarnings == index) {
                    this.idleTimer.reset();
                    this.forceUpdate();
                    return;
                }
            });
        });
    }

    render() {
        const { idleWarningNotif } = this.state.uiTimeOutDetails;
        const timeLeft = this.getTimeLeft();
        const idleTime = idleWarningNotif[this.state.idleWarnings];
        const timeout = 1000 * 60 * idleTime;
        return (
            <>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    events={['mousemove', 'mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove']}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    timeout={timeout} />
                <Modal className="session-exp-modal custom-column-modal-container" show={this.state.showModal && timeLeft != undefined && timeLeft != null} dialogClassName=""
                    onHide={e => { this.logout(e) }}>
                    <Modal.Header>
                        <Modal.Title>
                            <span>Session Expired</span>
                        </Modal.Title>
                    </Modal.Header>
                    <ModalBody>
                        <Row className="session-exp-row">
                            <Col xs={12} md={12} lg={12}>
                                <div className="session-exp-body">Your session will end in {timeLeft} minutes due to inactivity. Please choose to stay signed in or to log off.</div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <div className="session-exp-buttons">
                            <Button
                                id="logout-btn"
                                onClick={e => { this.logout(e) }}>
                                Log Out
                            </Button>
                            <Button
                                id="refresh-tkn-btn"
                                onClick={e => { this.continueSession(e) }}>
                                Continue Session
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
        return {
            ...authentication
        };
}
export default connect(mapStateToProps, mapDispatchToProps)(SessionExpModal);